import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { MainList } from "../../components/careplan/MainList";
import { MainContent } from "../../components/careplan/MainContent";
import { isEmpty } from "../../utils/isEmpty";
import { CareplanActionbar } from "../../components/careplan/CareplanActionbar";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import { FilterDropdown } from "../../components/careplan/Filter/FilterDropdown";
import axios from "axios";

const CarePlanPage = () => {
  const { token } = useAuthContext();
  const location = useLocation();
  const { mainId, careId, subId } = useParams();
  const careplanData = isEmpty(location.state?.careplanData)
    ? []
    : location.state.careplanData;

  const [isPhaseChecked, setIsPhaseChecked] = useState(true); // Manage the state of the main checkbox
  const [isTreatmentChecked, setIsTreatmentChecked] = useState(true); // Manage the state of the main checkbox
  const [isCitationChecked, setIsCitationChecked] = useState(true); // Manage the state of the main checkbox
  const [isExerciseChecked, setIsExerciseChecked] = useState(true); // Manage the state of the main checkbox
  const [isLifeStyleChecked, setIsLifeStyleChecked] = useState(true); // Manage the state of the main checkbox
  const [isEstimationChecked, setIsEstimationChecked] = useState(true); // Manage the state of the main checkbox

  const handlePhaseChange = () => {
    setIsPhaseChecked((prev) => !prev);
  };

  const handleTreatmentChange = () => {
    if (isTreatmentChecked) {
      setIsCitationChecked(false);
    }
    setIsTreatmentChecked((prev) => !prev);
  };

  const handleCitationChange = () => {
    if (isTreatmentChecked) {
      setIsCitationChecked((prev) => !prev);
    }
  };

  const handleExerciseChange = () => {
    setIsExerciseChecked((prev) => !prev);
  };

  const handleLifeStyleChange = () => {
    setIsLifeStyleChecked((prev) => !prev);
  };

  const handleEstimationChange = () => {
    setIsEstimationChecked((prev) => !prev);
  };

  const setCheckboxState = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/careplan/${mainId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    setIsPhaseChecked(response.data.phasechecked === 1 ? true : false);
    setIsTreatmentChecked(response.data.treatmentchecked === 1 ? true : false);
    setIsCitationChecked(response.data.citationchecked === 1 ? true : false);
    setIsExerciseChecked(response.data.exercisechecked === 1 ? true : false);
    setIsLifeStyleChecked(response.data.lifestylechecked === 1 ? true : false);
    setIsEstimationChecked(
      response.data.estimationchecked === 1 ? true : false
    );
  };

  useEffect(() => {
    if (mainId === "new-plan" && careId !== undefined && subId !== undefined) {
      setIsPhaseChecked(true);
      setIsTreatmentChecked(true);
      setIsCitationChecked(true);
      setIsExerciseChecked(true);
      setIsLifeStyleChecked(true);
      setIsEstimationChecked(true);
    }
    if (careId === "modify" || careId === "copy") {
      setCheckboxState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainId, subId, careId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
      }}
    >
      <MainList
        isPhaseChecked={isPhaseChecked}
        isTreatmentChecked={isTreatmentChecked}
        isCitationChecked={isCitationChecked}
        isExerciseChecked={isExerciseChecked}
        isLifeStyleChecked={isLifeStyleChecked}
        isEstimationChecked={isEstimationChecked}
        onPhaseChange={handlePhaseChange}
        onTreatmentChange={handleTreatmentChange}
        onCitationChange={handleCitationChange}
        onExerciseChange={handleExerciseChange}
        onLifeStyleChange={handleLifeStyleChange}
        onEstimationChange={handleEstimationChange}
      />
      <Box
        display={{ xs: "flex", md: "none" }}
        sx={{
          px: { xs: 3, md: 5, xl: 8 },
          pt: { xs: 3, md: 5, xl: 8 },
          ml: "auto",
          gap: 2,
        }}
      >
        <CareplanActionbar />
        <FilterDropdown
          isPhaseChecked={isPhaseChecked}
          isTreatmentChecked={isTreatmentChecked}
          isCitationChecked={isCitationChecked}
          isExerciseChecked={isExerciseChecked}
          isLifeStyleChecked={isLifeStyleChecked}
          isEstimationChecked={isEstimationChecked}
          onPhaseChange={handlePhaseChange}
          onTreatmentChange={handleTreatmentChange}
          onCitationChange={handleCitationChange}
          onExerciseChange={handleExerciseChange}
          onLifeStyleChange={handleLifeStyleChange}
          onEstimationChange={handleEstimationChange}
        />
      </Box>
      <MainContent
        data={careplanData}
        isPhaseChecked={isPhaseChecked}
        isTreatmentChecked={isTreatmentChecked}
        isCitationChecked={isCitationChecked}
        isExerciseChecked={isExerciseChecked}
        isLifeStyleChecked={isLifeStyleChecked}
        isEstimationChecked={isEstimationChecked}
      />
    </Box>
  );
};

export default CarePlanPage;
